import { memo } from 'react';

import { TaxReturnInitializer } from '@dec/shared';

import { type TaxReturnRequest } from '../../models/types';
import { useGetFormConnection, useGetGlobalTaxReturnValues } from '../../services/signalr.hooks';

export const Initializer = memo(({ readOnly }: { readOnly: boolean }) => {
  const connection = useGetFormConnection();
  const runtime = useGetGlobalTaxReturnValues();

  return (
    <TaxReturnInitializer<TaxReturnRequest>
      readOnly={readOnly}
      connection={connection}
      runtime={runtime}
    />
  );
});
